import { TestStatus } from '@viome/viome-base/src/usecase/Home/Home.model';
import dayjs from 'dayjs';
import { JourneyEducationTypes } from '@/utils/JourneyEducationTypes';

export const getProgressPercentage = (
  trackingData: TestStatus[] | undefined,
): number => {
  if (!trackingData || trackingData.length === 0) return 0;

  const selectedTracking =
    trackingData.find((data) => data.issue_in_current_status) ||
    trackingData[0];

  const processingState = selectedTracking.states.find(
    (state) => state.status !== 'COMPLETE',
  );

  if (!processingState) return 100;

  const progressMap: { [key: string]: number } = {
    Received: 4,
    'RNA Processing': 34,
    'AI Analyzing': 68,
    Results: 98,
  };

  return progressMap[processingState.stateName] || 12;
};

export const BloodSugarResponseId = 388;
export const PlantVirusesId = 11162;

export const ENERGY_SCOREID = 1372;
export const MOOD_MEMORY_SCOREID = 1402;
export const IMMUNITY_SCOREID = 1371;
export const HEART_METABOLIC_SCOREID = 1401;
export const GUT_DIGESTIVE_SCOREID = 1369;
export const ORAL_SCOREID = 1400;

export const gettingPlaceholderWithScoreId = (scoreId: number) => {
  switch (scoreId) {
    case GUT_DIGESTIVE_SCOREID:
      return JourneyEducationTypes.L2_DETAIL_GUT;
    case HEART_METABOLIC_SCOREID:
      return JourneyEducationTypes.L2_DETAIL_HEART;
    case IMMUNITY_SCOREID:
      return JourneyEducationTypes.L2_DETAIL_IMMUNE;
    case MOOD_MEMORY_SCOREID:
      return JourneyEducationTypes.L2_DETAIL_MOOD;
    case ORAL_SCOREID:
      return JourneyEducationTypes.L2_DETAIL_ORAL;
    case ENERGY_SCOREID:
      return JourneyEducationTypes.L2_DETAIL_ENERGY;
    default:
      return '';
  }
};

export const formatDayJSDate = (
  inputDate: string,
  outputDateFormat = 'YYYY-MM-DD',
) => {
  return dayjs(inputDate, 'MM/DD/YYYY').format(outputDateFormat);
};

export const getIsoString = (inputDateString: string) => {
  const dateString = new Date(inputDateString);
  return dateString.toISOString();
};

export enum ProductID {
  PRODUCT_ORAL_LOZENGES = 1,
  PRODUCT_SUPPLEMENTS = 2,
  PRODUCT_GUT_FORMULA = 3,
  PRODUCT_TOOTHPASTE_GEL = 4,
}

/**
 * The products the ingredients CSV export is enabled for. Opt-in: a product
 * gets a download only once it is listed here and the export has data for it.
 */
export const INGREDIENTS_CSV_PRODUCT_IDS: readonly number[] = [
  ProductID.PRODUCT_SUPPLEMENTS,
  ProductID.PRODUCT_GUT_FORMULA,
  ProductID.PRODUCT_TOOTHPASTE_GEL,
  ProductID.PRODUCT_ORAL_LOZENGES,
];

export const mapProductIdToTag = (productId: number) => {
  switch (productId) {
    case ProductID.PRODUCT_SUPPLEMENTS:
      return 'SUPPLEMENT';
    case ProductID.PRODUCT_GUT_FORMULA:
      return 'BIOTICS';
    case ProductID.PRODUCT_TOOTHPASTE_GEL:
      return 'TOOTHPASTE-GEL';
    case ProductID.PRODUCT_ORAL_LOZENGES:
      return 'LOZENGE';
    default:
      return 'NOT-SUBSCRIBED';
  }
};

export function monitorNetworkStatus(callback: (value: boolean) => void) {
  const updateStatus = () => callback(navigator.onLine);

  window.addEventListener('online', updateStatus);
  window.addEventListener('offline', updateStatus);

  return () => {
    window.removeEventListener('online', updateStatus);
    window.removeEventListener('offline', updateStatus);
  };
}
